module.exports = __webpack_public_path__ + "img/identifai-4.78be4650.jpeg";